import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'src/components/atoms/Button';
import Pill from 'src/components/atoms/Pill';
// import PillBox from "src/components/atoms/PillBox";
import Countdown from 'react-countdown';
import TableImage from 'src/components/atoms/TableImage';
import Page from 'src/components/layouts/Page';
import TableFilterable from 'src/components/organisms/TableFilterable';
// import { fakeOffers } from "src/data/fake/items";
import { toast } from 'react-toastify';
import MultipleViews from 'src/components/layouts/MultipleViews';
import OffersGrid from 'src/components/layouts/OffersGrid';
import EmptyPage from 'src/components/molecules/EmptyPage';
import SearchBar from 'src/components/organisms/SearchBar';
import {
  bulkDelete,
  bulkHide,
  clearState,
  deleteOffer,
  getPendingOffers,
  setView,
  updateFilter,
  updateOffer,
} from 'src/slices/offer';
import css from './moveme.module.scss';

import { getCounts } from 'src/slices/info';
import { checkPermissions, handleStatus } from 'src/slices/utils';

import { clearState as clearEmp } from 'src/slices/employee';

export default function Offers() {
  const dispatch = useDispatch();

  // change values
  const visibilityFilters = [
    { value: false, label: 'Active' },
    { value: true, label: 'Hidden' },
  ];

  const bulkActions = [
    { value: (offers) => dispatch(bulkDelete(offers)), label: 'Bulk Delete' },
    {
      value: (offers) => dispatch(bulkHide({ type: 'hide', offers })),
      label: 'Bulk Hide',
    },
    {
      value: (offers) => dispatch(bulkHide({ type: 'unhide', offers })),
      label: 'Bulk Unhide',
    },
  ];

  const { user, permissions } = useSelector((state) => state.auth);
  const { pendingOffers, status, pendingView } = useSelector((state) => state.offer);
  const { status: empStatus } = useSelector((state) => state.employee);

  const filter = useSelector((state) => state.offer.filters.offers);
  const { counts } = useSelector((state) => state.info);
  const { coords } = useSelector((state) => state.location);
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (coords.lat && coords.long) {
      dispatch(getPendingOffers());
    }
  }, [filter, dispatch, coords]);

  useEffect(() => {
    dispatch(getPendingOffers());
    dispatch(getCounts());
  }, []);

  useEffect(() => {
    handleStatus(status.updateOffer, () => dispatch(clearState(status.updateOffer)), {
      isLoading: { toast: false },
      isSuccess: { toast: false },
    });
    handleStatus(status.deleteOffer, () => dispatch(clearState(status.deleteOffer)));
  }, [status]);

  useEffect(() => {
    handleStatus(empStatus.approveResource, () => dispatch(clearEmp(empStatus.approveResource)), {
      isLoading: { toast: false },
    });
  }, [empStatus.approveResource]);

  const handleMore = () => {
    dispatch(updateFilter({ offers: { limit: (page + 1) * filter.skip } }));
    setPage(page + 1);
  };

  useEffect(() => {
    dispatch(updateFilter({ items: { keyword: '', page: 1, skip: 200 } }));
  }, [dispatch]);

  const offerTimeRenderer = ({ formatted, completed, days, props }) => {
    // if (Date.now() < props.start) {
    // 	return (
    // 		<Pill
    // 			label={`${days > 0 ? `Starts in ${days} Days,` : ''} ${formatted.hours}:${formatted.minutes}:${formatted.seconds}`}
    // 			color='amber'
    // 			variant='secondary'
    // 			iconLeft='fad fa-stopwatch'
    // 		/>
    // 	)
    // }
    if (completed) {
      return (
        <Pill
          label="Archived"
          variant="secondary"
          // iconLeft="fad fa-stopwatch"
          color="red"
        />
      );
    }
    return (
      // <Pill
      <>
        {`${days > 0 ? `${days} Days,` : ''} ${formatted.hours}:${formatted.minutes}:${
          formatted.seconds
        }`}
      </>
      //     color="gray"
      //     variant="secondary"
      //     iconLeft="fad fa-stopwatch"
      // />
    );
  };
  function handleDelete(message, deleteFunction) {
    const ConfirmActionModal = ({ closeToast, toastProps }) => (
      <div>
        Are you sure you want to delete this offer? This action cannot be undone.
        <div className={css.buttons}>
          <Button color="green" action={() => deleteFunction()} label={message}></Button>
          <Button color="red" label={'Dismiss'}></Button>
        </div>
      </div>
    );
    toast(ConfirmActionModal, { autoClose: false });
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Image',
        accessor: 'photos',
        disableSortBy: true,
        width: '80px',
        Cell: (props) => (
          <TableImage
            iconUnicode=""
            src={props.cell.row.original?.photos?.[0]}
            type="rect"
            alt={props.cell.row.values.offerName}
          />
        ),
      },
      {
        Header: 'Name',
        accessor: 'name',
      },

      // {
      //     Header: "Items",
      //     accessor: "items",
      //     disableSortBy: true,
      //     Cell: (props) => (
      //         <>
      //             <div className={css["table-multiple-images"]}>
      //                 {props.cell.row.original.offerPhotos
      //                     .slice(0, 2)
      //                     .map((item) => {
      //                         return (
      //                             <TableImage
      //                                 iconUnicode=""
      //                                 src={item}
      //                                 alt={item}
      //                             />
      //                         );
      //                     })}
      //                 {props.cell.row.values.items.length >= 3 && (
      //                     <span>
      //                         +{props.cell.row.values.items.length - 2}{" "}
      //                         More
      //                     </span>
      //                 )}
      //             </div>
      //         </>
      //     ),
      // },
      {
        Header: 'Price',
        accessor: 'price',
        Cell: (props) => `$${props.cell.row.values.price.toFixed(2)}`,
        width: 'auto',
      },
      {
        Header: 'Sold',
        accessor: 'sold',
        Cell: (props) => (
          <>{parseFloat(props.cell.row.original?.initQty - props.cell.row.original?.qty)}</>
        ),
      },
      {
        Header: 'Left',
        accessor: 'qty',
      },
      // {
      //    accessor: "remaining"
      //
      {
        Header: 'Status',
        accessor: 'active',
        Cell: function (props) {
          let start = new Date(props.cell.row.original.startDate);
          let end = new Date(props.cell.row.original.endDate);
          return (
            <Countdown
              start={start}
              date={Date.now() < start ? start : end}
              renderer={offerTimeRenderer}
            />
          );
        },
      },

      {
        // Header: "Actions",
        Header: '',
        accessor: 'actions',
        disableSortBy: true,
        Cell: (props) => (
          <div className={css['table-actions']}>
            {checkPermissions(permissions, { update: ['offers'] }).hasPermission && (
              <>
                <Button
                  iconLeft="fad fa-pencil"
                  color="gray"
                  variant="secondary"
                  size="s"
                  href={`/offers/${props.cell.row.original._id}`}
                />
                <Button
                  iconLeft={
                    props.cell.row.original.status == 'active' ? 'fas fa-eye' : 'fas fa-eye-slash'
                  }
                  color="gray"
                  variant="secondary"
                  size="s"
                  action={() =>
                    dispatch(
                      updateOffer({
                        id: props.cell.row.original._id,
                        status: props.cell.row.original.status == 'active' ? 'hidden' : 'active',
                      }),
                    )
                  }
                />
              </>
            )}
            {checkPermissions(permissions, { delete: ['offers'] }).hasPermission && (
              <Button
                iconLeft="fad fa-trash-alt"
                color="red"
                variant="secondary"
                size="s"
                action={() =>
                  handleDelete(`Delete '${props.cell.row.original.name}'`, () =>
                    dispatch(deleteOffer(props.cell.row.original.id)),
                  )
                }
              />
            )}
          </div>
        ),
      },
    ],

    [],
  );

  const handleorder = (selectedOption) => {
    const data = {
      merchantId: user.id,
      resource: 'offers',
      status: selectedOption.value,
    };
    // dispatch(getOffer(data))
  };

  return (
    <Page>
      <MultipleViews
        showControls
        defaultView="grid" // grid == card view
        isEmpty={pendingOffers.length == 0}
        setView={(view) => dispatch(setView({ pending: view }))}
        view={pendingView}
        isSelected={selected.length == 0}
        isLocked={!permissions.read.includes('pendingOffers')}
        searchBar={
          <SearchBar
            onChange={(e) => dispatch(updateFilter({ offers: { keyword: e.target.value } }))}
            value={filter.keyword}
            dataName="offer"
            createLink="/offers/new"
            options={bulkActions}
            view={pendingView}
            selected={selected}
          />
        }
        tableView={
          <TableFilterable
            columns={columns}
            data={pendingOffers}
            dataName="offer"
            // itemsSelectable={true}
            // bulkActions={actions}
            // rename this props!
            visibilityFilters={visibilityFilters}
            handleorder={handleorder}
            status="offers"
            showBar={false}
            handleMore={handleMore}
            count={counts.pendingOffers}
            setSelected={(selected) => setSelected(selected)}
          />
        }
        gridView={
          <>
            <OffersGrid
              offers={pendingOffers}
              handleMore={handleMore}
              count={counts.pendingOffers}
            />
          </>
        }
        emptyView={
          <>
            <EmptyPage
              title="You don’t have any active offers"
              text="Want to attract shoppers? Have surplus inventory to sell quickly?"
              iconName="fad fa-tags"
              button={
                <Button
                  label="Create Offer"
                  iconLeft="fad fa-plus"
                  href="/offers/new"
                  // action={!permissions.create.includes('offers')}
                  // disabled={!permissions.create.includes('offers')}
                  // color={
                  // 	!permissions.create.includes('offers') ? 'gray' : 'blue'
                  // }
                  // variant={
                  // 	!permissions.create.includes('offers')
                  // 		? 'secondary'
                  // 		: 'primary'
                  // }
                />
              }
            />
          </>
        }
        lockedView={
          <EmptyPage
            title="You don’t have permission to view anything on this page"
            text="Ask your employer for access"
            iconName="fad fa-lock"
          />
        }
      />
    </Page>
  );
}
